import * as React from 'react';

import { ControlIcons } from 'owa-control-icons';
import { LocationCardProps } from './LocationCardWrapper';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { KeyCodes } from 'office-ui-fabric-react/lib/Utilities';

import calculateMapUrl from '../utils/calculateMapUrl';
import getBingUrl from '../utils/getBingUrl';
import strings from 'owa-strings/owa-calendar-strings';

let styles = require('./LocationCard.scss');
let classNames = require('classnames/bind').bind(styles);

const MAP_WIDTH = 290;
const MAP_HEIGHT = 135;

export default class LocationExpandedCard extends React.Component<LocationCardProps, any> {
    render() {
        let locationPersona = this.props.locationPersona;
        let latitude =
            locationPersona && locationPersona.postalAddress
                ? locationPersona.postalAddress.Latitude
                : undefined;
        let longitude =
            locationPersona && locationPersona.postalAddress
                ? locationPersona.postalAddress.Longitude
                : undefined;
        let imageUrl: string = calculateMapUrl(latitude, longitude, MAP_WIDTH, MAP_HEIGHT);

        return (
            <span>
                {locationPersona.displayAddress && (
                    <div className={styles.cardSection}>
                        <div className={styles.sectionHeader}>
                            {strings.locationCardInformationLabel}
                        </div>
                        <Icon className={styles.icon} iconName={ControlIcons.Poi} />
                        <div
                            tabIndex={0}
                            aria-label={locationPersona.displayName}
                            role="button"
                            className={classNames(styles.linkToBing, styles.informationRow)}
                            onClick={this.openDirections}
                            onKeyDown={this.onKeyDown}>
                            {locationPersona.displayAddress}
                        </div>
                        <div className={styles.clearFix} />
                    </div>
                )}
                {imageUrl && (
                    <div className={styles.cardSection}>
                        <div className={styles.sectionHeader}>{strings.locationCardMapLabel}</div>
                        <img
                            className={styles.linkToBing}
                            src={imageUrl}
                            onClick={this.openDirections}
                            onKeyDown={this.onKeyDown}
                        />
                    </div>
                )}
            </span>
        );
    }

    private openDirections = () => {
        if (this.props.locationPersona.postalAddress) {
            window.open(
                getBingUrl(
                    this.props.locationPersona.postalAddress.Latitude,
                    this.props.locationPersona.postalAddress.Longitude,
                    this.props.locationPersona.postalAddress.FormattedAddress,
                    this.props.locationPersona.displayName
                ),
                '_blank'
            );
        }
    };

    private onKeyDown = (ev: React.KeyboardEvent<any>) => {
        if (ev.which == KeyCodes.enter) {
            this.openDirections();
        }
    };
}
